'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.images = undefined;

var _getStaticAsset = require('MeetingsBase/utils/getStaticAsset');

var images = exports.images = {
  PREVIEW_DESKTOP: (0, _getStaticAsset.fromSalesImages)('meetings/public-preview-desktop.svg'),
  PREVIEW_MOBILE: (0, _getStaticAsset.fromSalesImages)('meetings/public-preview-mobile.svg'),

  TIP_ICON: (0, _getStaticAsset.fromSalesImages)('meetings/tip-icon.svg'),
  HEADLINE: (0, _getStaticAsset.fromSalesImages)('meetings/headline2.png'),
  MEETINGS_LINK_CREATED: (0, _getStaticAsset.fromSalesImages)('meetings/meeting-link-created.svg'),
  DEMO_SCREEN: (0, _getStaticAsset.fromSalesImages)('meetings/demo_screen.png'),
  WELCOME_CALENDAR: (0, _getStaticAsset.fromSalesImages)('meetings/welcome-calendar.svg'),

  SETUP_EXAMPLE_HEADLINE: (0, _getStaticAsset.fromSalesImages)('meetings/setup-example-headline.png'),

  PERSONAL_AVAILABILITY_ILLUSTRATION: (0, _getStaticAsset.fromSalesImages)('meetings/personal-illustration.svg'),
  GROUP_AVAILABILITY_ILLUSTRATION: (0, _getStaticAsset.fromSalesImages)('meetings/group.svg'),
  ROUNDROBIN_AVAILABILITY_ILLUSTRATION: (0, _getStaticAsset.fromSalesImages)('meetings/round-robin.svg'),
  TEAM_AVAILABILITY_ILLUSTRATION: (0, _getStaticAsset.fromSalesImages)('meetings/team-illustration.svg'),

  ORANGE_SUCCESS: (0, _getStaticAsset.fromSalesImages)('icons/success-orange-simple.svg'),
  GREEN_SUCCESS: (0, _getStaticAsset.fromSalesImages)('icons/success-green-checkmark.svg'),
  BALLOONS: (0, _getStaticAsset.fromSalesImages)('meetings/balloons.svg'),
  AVATAR_ICON: (0, _getStaticAsset.fromSalesImages)('meetings/avatar-icon.svg'),

  // FREEMIUM MEETINGS
  FREEMIUM_BRANDING: (0, _getStaticAsset.fromSalesImages)('meetings/freemium/brand.gif'),
  FREEMIUM_EMBED: (0, _getStaticAsset.fromSalesImages)('meetings/freemium/embed.png'),
  FREEMIUM_TEAM: (0, _getStaticAsset.fromSalesImages)('meetings/freemium/team.png'),
  FREEMIUM_FORM: (0, _getStaticAsset.fromSalesImages)('meetings/freemium/forms.gif'),
  FREEMIUM_CUSTOM_AVAILABILITY: (0, _getStaticAsset.fromSalesImages)('meetings/freemium/freemium-availability.png'),
  FREEMIUM_DEFAULT_NAMESPACE: (0, _getStaticAsset.fromSalesImages)('meetings/freemium/meetings-url-animated.gif'),
  // Marketing PQL
  BOOKED_CALENDAR_ILLUSTRATION: (0, _getStaticAsset.fromSalesImages)('meetings/pql/booked-calendar.svg'),
  BEGINNING_QUOTE: (0, _getStaticAsset.fromSalesImages)('meetings/pql/beginning-quote.svg'),
  END_QUOTE: (0, _getStaticAsset.fromSalesImages)('meetings/pql/end-quote.svg')
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/constants/images.js
// module id = 500
// module chunks = 0